import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
import ArgonDashboard from "./plugins/argon-dashboard";
import BootstrapVue from "bootstrap-vue";
import VueNumberInput from "@chenfengyuan/vue-number-input";
import Axios from "axios";
import Vuelidate from "vuelidate";
import VueThailandAddress from "vue-thailand-address";
import VueThaiAddressInput from "vue-thai-address-input";
import "vue-thai-address-input/dist/vue-thai-address-input.css";
import "vue-thailand-address/dist/vue-thailand-address.css";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import BlockUI from "vue-blockui";
import VueHtmlToPaper from "vue-html-to-paper";
import moment from "moment";
import numFormat from "vue-filter-number-format";
import firebase from "firebase/app";
import "firebase/storage";
import VueExcelXlsx from "vue-excel-xlsx";
import JsonExcel from "vue-json-excel";
import Autocomplete from "@trevoreyre/autocomplete-vue";
import "@trevoreyre/autocomplete-vue/dist/style.css";
import userRoles from "./helpers/userRoles";
import walletMetadata from "./helpers/walletMetadata";
import shopMetadata from "./helpers/shopMetadata";
import globalDatetime from "./constants/globalDatetime";
import * as VueGoogleMaps from "vue2-google-maps";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
// import draggable from 'vuedraggable'
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { Icon } from "@iconify/vue2";
import configPOPTheme from "@/config/POPTheme";
import { createAuth0Client } from "@auth0/auth0-spa-js";
import { storageCache } from "@/helpers/auth0";
import { getRole } from "@/plugins/role";
import VuePdf from "vue-pdf";
import VueMeta from "vue-meta";

Vue.use(VueMeta);

Vue.component("vue-pdf", VuePdf);

// import VuePdfApp from "vue-pdf-app";
// Vue.component("vue-pdf-app", VuePdfApp);
//Hotjar Tracking Code
const hjid = process.env.VUE_APP_HOTJAR_ID;
if (hjid) {
  (function (h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid, hjsv: 6 };
    a = o.getElementsByTagName("head")[0];
    r = o.createElement("script");
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
}
//--------------------

const options = {
  name: "_new",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
  ],
};

firebase.initializeApp(
  configPOPTheme.firebaseConfig || {
    apiKey: "AIzaSyDqpusN9El2U2V7wdqHRCfZP6vMRFczq4A",
    authDomain: "pop-shippop.firebaseapp.com",
    databaseURL: "https://pop-shippop.firebaseio.com",
    projectId: "pop-shippop",
    storageBucket: "pop-shippop.appspot.com",
    messagingSenderId: "509671962341",
    appId: "1:509671962341:web:6ee61ef2be68724f",
    measurementId: "G-YT5DWPBVXL",
  }
);

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE,
    libraries: "places", // This is required if you use the Autocomplete plugin
    region: "TH",
    language: "th",
    v: "3.40",
  },
});

Vue.config.warnHandler = function (msg) {
  if (
    msg !==
    "The .native modifier for v-on is only valid on components but it was used on <a>."
  ) {
    // eslint-disable-next-line
    console.error(msg);
  }
};

// console.log('window.liff', window.liff)
import VConsole from "vconsole";
if (process.env.VUE_APP_V_CONSOLE) {
  const vConsole = new VConsole();
}

Vue.prototype.$domain = process.env.VUE_APP_DOMAIN_PRODUCTION;
Vue.prototype.$liff = window.liff;
Vue.prototype.$USER_LOGIN = userRoles;
Vue.prototype.$WALLET_METADATA = walletMetadata;
Vue.prototype.$SHOP_METADATA = shopMetadata;
Vue.prototype.$NOW = globalDatetime;
Vue.prototype.moment = moment;
Vue.prototype.$API_URL = process.env.VUE_APP_API;
Vue.prototype.$http = Axios;
Vue.prototype.$firebase = firebase;
Vue.prototype.$THEME = configPOPTheme || false;
Vue.prototype.$ROLE = getRole;
Vue.config.productionTip = false;
Vue.use(VueThaiAddressInput);
Vue.use(BootstrapVue);
Vue.use(VueHtmlToPaper, options);
Vue.use(ArgonDashboard);
Vue.use(VueNumberInput);
Vue.use(Vuelidate);
Vue.use(VueThailandAddress);
Vue.use(BlockUI);
Vue.use(VueExcelXlsx);
Vue.use(Autocomplete);
Vue.filter("numFormat", numFormat);

Vue.component("Icon", Icon);
Vue.component("v-select", vSelect);
Vue.component("Datepicker", Datepicker);
Vue.component("downloadExcel", JsonExcel);
Vue.component("date-range-picker", DateRangePicker);

Vue.component("vue-timepicker", VueTimepicker);

Vue.mixin({
  mounted() {
    this.autoload();
  },
  data() {
    return {
      WALLET: {
        status: false,
        error: null,
        available_balance: 0,
        peg_balance: 0,
        balance: 0,
      },
    };
  },
  methods: {
    autoload() {
      try {
        this.WALLET = JSON.parse(localStorage.getItem("wallet"));
      } catch (err) {
        // eslint-disable-next-line
        console.error(`mainjs_mixin:: ${err}`);
      }
    },
  },
  computed: {
    $WALLET: {
      get: function () {
        return this.WALLET;
      },
      set: function (newWallet) {
        this.WALLET = newWallet;
      },
    },
    $TOKEN() {
      return localStorage.getItem("access_token");
    },

    main_use_walletV2() {
      return ["shippop"].includes(this.$THEME.name)
    },
    main_is_production() {
      return process.env.NODE_ENV === "production"
    }
  },
});

(async () => {
  try {
    const auth0 = await createAuth0Client({
      clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
      domain: process.env.VUE_APP_AUTH0_DOMAIN,
      authorizationParams: {
        redirect_uri: window.location.origin + "/callback",
        organization: process.env.VUE_APP_AUTH0_ORGANIZATION,
      },
      cache: storageCache,
    }).catch((err) => {
      // eslint-disable-next-line
      console.error(`createAuth0Client:: ${err}`);
    });

    Vue.prototype.$auth0 = auth0;
  } catch (err) {
    // eslint-disable-next-line
    console.error(`auth0Client:: ${err}`);
  }

  new Vue({
    render: (h) => h(App),
    router,
  }).$mount("#app");
})();
